module.exports = __webpack_public_path__ + "img/level-1.03858274.webp";